import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { LEARNING_MAP_CONTENT_TYPE } from '@/utils/constants';
import PullOutMoreCard from '@/components/cards/tree-pull-out/pull-out-more-card/pull-out-more-card';

@Component({
    name: 'learning-map-pullout',
    components: {
        'material-icon': GoogleMaterialIcon,
        'mc-icon': MCIcon,
        'pull-out-more': PullOutMoreCard,
    },
})

export default class LearningMapPullout extends Vue {

    // ------------------------------------------------------------------
    // Properties

    @Prop()
    private pullOutInfo: any;

    @Prop()
    private pullOutContents: any;

    private isShowMore: boolean = false;

    // ------------------------------------------------------------------------
    // Actions
    private closeContainer() {
        if (this.$parent) {
            this.$parent.$data.showPullout = false;
        }
    }

    private onShowMore() {
        this.isShowMore = !this.isShowMore;
        (this.$el as HTMLElement).style.width = this.isShowMore ? '100%' : '450px';
    }

}
